import { useState } from "react";

import XMarkIcon from "../../icons/xMark.icon";
import PlusIcon from "../../icons/plus.icon";
import { inputCss } from "../reuseables/native.comp";

export default function MailList({ fieldName, label, methods }: { fieldName: string; label: string; methods: any }) {
  const [emailInput, setEmailInput] = useState("");

  function addEmail() {
    let mailList = methods.getValues(fieldName);

    if (mailList === undefined) {
      mailList = [];
    }

    if (!mailList.find((e) => e === emailInput)) {
      mailList.push(emailInput);
      methods.setValue(fieldName, mailList);
    }
    setEmailInput("");
  }

  function removeEmail(email: string) {
    const mailList = methods.getValues(fieldName);
    const newList = [...mailList].filter((m) => m !== email);
    methods.setValue(fieldName, newList);
  }

  return (
    <div className="mb-6 space-y-2">
      <p>{label}:</p>
      <div className="flex items-center gap-2">
        <input value={emailInput} type="email" onChange={(e) => setEmailInput(e.target.value)} className={inputCss} />
        <button type="button" onClick={addEmail} className="bg-her-blue text-white rounded-lg p-2">
          <PlusIcon className="w-5 h-5 text-white" />
        </button>
      </div>
      <div className="mb-2">
        {methods.watch(fieldName)?.map((email) => (
          <div key={email} className="flex items-center gap-2">
            <p>{email}</p>
            <button type="button" onClick={() => removeEmail(email)} className="cursor-pointer">
              <XMarkIcon className="w-5 h-5 text-red-400" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
